/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_StockInputs */

const en_samples_stock = /** @type {(inputs: Samples_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samples Stock`)
};

const es_samples_stock = /** @type {(inputs: Samples_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock de muestras`)
};

/**
* | output |
* | --- |
* | "Samples Stock" |
*
* @param {Samples_StockInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_stock = /** @type {((inputs?: Samples_StockInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_StockInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_stock(inputs)
	return es_samples_stock(inputs)
});